// extracted by mini-css-extract-plugin
module.exports = {"container":"CheckBox_container__2wCRW","checkmark":"CheckBox_checkmark__3r0yl"};